import { MijnRoute } from '../../../mijn-navigatie.model';

export const TELEPHONY_CONSENT: MijnRoute = {
    path: 'toestemming-telefonie',
    navigationEvent: 'toTelephonyConsent',
    regex: /^\/zelf-regelen\/privacy\/toestemming-telefonie$/,
    webcomponent: 'mijn-telephony-consent-webcomponent'
};
